import React from 'react';
import { LockIcon, ToggleLeftIcon, ShieldCheckIcon } from 'lucide-react';
export const PrivacySection: React.FC = () => {
  return <section className="py-16 md:py-24 bg-cloud" data-id="element-225">
      <div className="section-container" data-id="element-226">
        <div className="text-center mb-12" data-id="element-227">
          <h2 className="text-3xl md:text-4xl font-literata font-medium text-deep-juniper mb-4" data-id="element-228">
            Your privacy is paramount
          </h2>
          <p className="text-lg text-plum-gray max-w-2xl mx-auto" data-id="element-229">
            Privacy isn't a feature — it's the foundation of everything we
            build.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-230">
          <div className="card hover:scale-105 transition-all duration-300" data-id="element-231">
            <div className="w-14 h-14 rounded-full bg-rejoy-coral/20 flex items-center justify-center mb-4" data-id="element-232">
              <LockIcon className="text-rejoy-coral" size={28} data-id="element-233" />
            </div>
            <h3 className="text-xl font-literata font-medium text-deep-juniper mb-3" data-id="element-234">
              End-to-End Encryption
            </h3>
            <p className="text-plum-gray" data-id="element-235">
              Your data is private by design. Our secure infrastructure ensures
              your information remains confidential at every step.
            </p>
          </div>
          <div className="card hover:scale-105 transition-all duration-300" data-id="element-236">
            <div className="w-14 h-14 rounded-full bg-deep-juniper/20 flex items-center justify-center mb-4" data-id="element-237">
              <ToggleLeftIcon className="text-deep-juniper" size={28} data-id="element-238" />
            </div>
            <h3 className="text-xl font-literata font-medium text-deep-juniper mb-3" data-id="element-239">
              You Control Your Paths
            </h3>
            <p className="text-plum-gray" data-id="element-240">
              Choose what's shared with therapists and what remains private. You
              always maintain ownership of your personal information.
            </p>
          </div>
          <div className="card hover:scale-105 transition-all duration-300" data-id="element-241">
            <div className="w-14 h-14 rounded-full bg-mint-sage/40 flex items-center justify-center mb-4" data-id="element-242">
              <ShieldCheckIcon className="text-deep-juniper" size={28} data-id="element-243" />
            </div>
            <h3 className="text-xl font-literata font-medium text-deep-juniper mb-3" data-id="element-244">
              HIPAA Compliant
            </h3>
            <p className="text-plum-gray" data-id="element-245">
              We meet all clinical data standards and maintain the highest level
              of security protocols for healthcare information.
            </p>
          </div>
        </div>
      </div>
    </section>;
};